import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { Fragment } from 'react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../redux/store';
import { isTestEnvironment } from '../../../utils/utils';
import { ActivePlayerHaloContainer } from '../player/activePlayerHaloContainer';
import { PokerSeat } from '../player/pokerSeat';
const PIXI_DATA = isTestEnvironment() ? { type: 'seated-players' } : null;
export const PokerSeatsContainer = () => {
    const seatedPlayerSeatIndexes = useAppSelector((state) => state.poker.seatedPlayerSeatIndexes, shallowEqual);
    return (_jsx(Container, { "pixi-data": PIXI_DATA, children: seatedPlayerSeatIndexes.map((seatIndex) => (_jsxs(Fragment, { children: [_jsx(ActivePlayerHaloContainer, { seatIndex: seatIndex }), _jsx(PokerSeat, { seatIndex: seatIndex })] }, seatIndex))) }));
};
